/**
 * How the Inquiries Desk (src/pages/InquiriesDesk.jsx) keeps up with
 * customers who keep talking while it is open: the open conversation and the
 * queue are re-read in the background (Sheena, 2026-10-25: her answer to the
 * team's note never showed, because the transcript was cached for the whole
 * session). Only while the tab is visible.
 */
// Founder, 2026-10-28: new messages "don't show until I go to a different
// tab then come back and maybe refresh a few times". Faster re-reads, never
// from the browser's cache (see the `no-store` fetches in InquiriesDesk.jsx).
export const TRANSCRIPT_REFRESH_MS = 10 * 1000;
export const LIST_REFRESH_MS = 20 * 1000;

/** Same conversation, nothing new: keep the rendered one (no re-render, no scroll). */
export function sameTranscript(a, b) {
  if (!a || !b) return false;
  const last = (list) => (list?.length ? list[list.length - 1]?.id : null);
  return a.messages?.length === b.messages?.length
    && last(a.messages) === last(b.messages)
    && (a.consults?.length || 0) === (b.consults?.length || 0);
}
